/**
 * Traffic Section Transformers
 * Aggregates all traffic-related transformers and provides section-level utilities
 */

import { transformTrafficRank } from './trafficRankTransformer';
import { transformVisitorsLocalization } from './visitorsLocalizationTransformer';

// Re-export individual transformers
export { transformTrafficRank } from './trafficRankTransformer';
export { transformVisitorsLocalization } from './visitorsLocalizationTransformer';

/**
 * Transforms traffic-related criteria from WooRank API response.
 *
 * @param {Object} apiData - The SEO audit data object (already response.data from API)
 * @returns {Object} transformed traffic section data
 */
export const transformTrafficSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const trafficRank = transformTrafficRank(criteria?.traffic_popularity);

  // Visitors localization key not confirmed in sample payload; try a few likely keys.
  const visitorsCriteria =
    criteria?.visitors_loc ||
    criteria?.visitors_localization ||
    criteria?.visitors_locs ||
    criteria?.visitor_localization ||
    null;

  const visitorsLocalization = transformVisitorsLocalization(visitorsCriteria);

  const allResults = [trafficRank, visitorsLocalization];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    trafficRank,
    visitorsLocalization,
  };
};

export default transformTrafficSection;


